module.exports = __webpack_public_path__ + "img/video4.c402204f.png";